import request from '@/utils/request'

// 查询发现板块-频道分类列表
export function listDiscoveryChannelCategory(query) {
  return request({
    url: '/discovery/discovery/channel/category/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询发现板块-频道分类分页
export function pageDiscoveryChannelCategory(query) {
  return request({
    url: '/discovery/discovery/channel/category/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询发现板块-频道分类详细
export function getDiscoveryChannelCategory(data) {
  return request({
    url: '/discovery/discovery/channel/category/detail',
    method: 'get',
    params: data
  })
}

// 新增发现板块-频道分类
export function addDiscoveryChannelCategory(data) {
  return request({
    url: '/discovery/discovery/channel/category/add',
    method: 'post',
    data: data
  })
}

// 修改发现板块-频道分类
export function updateDiscoveryChannelCategory(data) {
  return request({
    url: '/discovery/discovery/channel/category/edit',
    method: 'post',
    data: data
  })
}

// 删除发现板块-频道分类
export function delDiscoveryChannelCategory(data) {
  return request({
    url: '/discovery/discovery/channel/category/delete',
    method: 'post',
    data: data
  })
}
